import type { Prototype } from "../prototype-types";

export const yukiMoPrototypes: Prototype[] = [
  {
    id: "ym-faire-direct-connect-trade-show-tools",
    name: "Faire Direct Connect trade show tools",
    path: "/ym/faire-direct-connect-trade-show-tools",
    description:
      "More tools section; QR card opens a modal (Trade show / Faire Direct Link) with static QR placeholder.",
    owner: "Yuki Mo",
    createdAt: "2026-05-04",
    lastUpdated: "2026-05-04",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4eb80b8b9d73a2874062442c35773e10b165c2dcb85f39162b53b3e2fbf91f66.png",
    creationTool: "cursor",
  },
  {
    id: "ym-brand-terms-checkout",
    name: "Brand Terms at Checkout",
    path: "/ym/brand-terms-checkout",
    description:
      "Soft Terms required on brand cards at checkout, with LiveToolbar toggles for terms treatment and stacking states (Insider, promo, Faire Source, free returns, import fees, summary banners).",
    owner: "Yuki Mo",
    createdAt: "2026-07-30",
    lastUpdated: "2026-07-31",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/10b1198eaab6eee89efa0538b783a9c455caead5df8a56111ce61c906fa86140.png",
    creationTool: "cursor",
  },
  {
    id: "ym-configurable-widget-mobile-channels",
    name: "Configurable widget mobile sales channels",
    path: "/ym/configurable-widget-mobile-channels",
    description:
      "Mobile sales-channel layouts B (compact stacked), C (CTA first + what’s included), and E (channel chooser). Toggle layout, Faire position, and tall vs short brand fonts to compare the first viewport.",
    owner: "Yuki Mo",
    createdAt: "2026-09-10",
    lastUpdated: "2026-09-10",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail: "/images/thumbnails/ym-configurable-widget-mobile-channels.png",
    creationTool: "cursor",
    project: "Configurable widget",
  },
  {
    id: "ym-configurable-widget-mobile-exclusive",
    name: "Configurable widget exclusive + bestsellers",
    path: "/ym/configurable-widget-mobile-exclusive",
    description:
      "Mobile Faire Exclusive + Bestsellers with smaller type and flush side margins. Toggle the hero image on or off, and compare tall vs short brand fonts against the first viewport.",
    owner: "Yuki Mo",
    createdAt: "2026-09-10",
    lastUpdated: "2026-09-10",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail: "/images/thumbnails/ym-configurable-widget-mobile-exclusive.png",
    creationTool: "cursor",
    project: "Configurable widget",
  },
];
